// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lPFa","question":"styles_question__19qCE","description":"styles_description__3SBeY"};